// Shared gradient and color constants for interstitial templates using theme variables
export const INTERSTITIAL_GRADIENTS = {
  // Background gradient using theme colors
  background:
    'linear-gradient(167deg, rgba(116, 130, 134, 0.36) -30.17%, rgba(178, 202, 204, 0.48) -8.06%, rgba(255, 252, 249, 0.60) 29.26%, rgba(178, 202, 204, 0.48) 85.57%, rgba(116, 130, 134, 0.36) 127.17%), linear-gradient(349deg, var(--color-ashgray) -29.79%, var(--color-silver) 5.22%, var(--color-gray) 41.19%, var(--color-silver) 78.61%, var(--color-ashgray) 118.66%)',

  backgroundTeal:
    'linear-gradient(167deg, rgba(116, 130, 134, 0.15) -3.98%, rgba(178, 202, 204, 0.20) 18.32%, rgba(255, 252, 249, 0.25) 48.83%, rgba(178, 202, 204, 0.20) 80.2%, rgba(116, 130, 134, 0.15) 110.46%), linear-gradient(269deg, #206866 -12.55%, #053736 108.38%)',

  statisticsBackground:
    'var(--gray-bg-fullscreen, linear-gradient(167deg, rgba(116, 130, 134, 0.36) -15.46%, rgba(178, 202, 204, 0.48) 4.58%, rgba(255, 252, 249, 0.60) 38.41%, rgba(178, 202, 204, 0.48) 89.46%, rgba(116, 130, 134, 0.36) 127.17%), linear-gradient(351deg, #898380 -32.26%, #ACA6A3 10.76%, #D0D0D0 54.96%, #ACA6A3 100.94%, #898380 150.15%))',

  // Multi-testimonial background gradient
  multiTestimonial:
    'linear-gradient(167deg, rgba(116, 130, 134, 0.42) -15.46%, rgba(178, 202, 204, 0.56) 4.58%, rgba(255, 252, 249, 0.70) 38.41%, rgba(178, 202, 204, 0.56) 89.46%, rgba(116, 130, 134, 0.42) 127.17%), linear-gradient(350deg, rgba(137, 131, 128, 0.90) -57.4%, rgba(172, 166, 163, 0.90) -7.49%, rgba(208, 208, 208, 0.90) 61.53%, rgba(172, 166, 163, 0.90) 124.23%, rgba(137, 131, 128, 0.90) 191.34%)',

  // Headline gradient using theme colors
  headline:
    'linear-gradient(281deg, var(--color-amberblack) -5.79%, var(--color-silver) 47.93%, var(--color-amberblack) 101.66%)',

  // Multi-testimonial headline gradient using theme colors
  multiTestimonialHeadline:
    'linear-gradient(281deg, var(--color-amberblack) -5.79%, var(--color-silver) 47.93%, var(--color-amberblack) 101.66%)',

  // Default headline gradient for non-loading templates
  defaultHeadline: 'linear-gradient(281deg, #2D231D -5.79%, #78665C 47.93%, #2D231D 101.66%)',

  // Linear progress headline gradient
  linearProgressHeadline:
    'linear-gradient(92deg, rgba(239, 238, 238, 0.90) 0.91%, rgba(255, 253, 250, 0.90) 49.71%, rgba(255, 253, 252, 0.90) 65.04%, rgba(236, 236, 236, 0.90) 104.56%)',

  // Callout background using theme colors
  callout:
    'linear-gradient(92deg, rgba(239, 238, 238, 0.30) 0.91%, var(--color-paper-half) 49.71%, rgba(255, 253, 252, 0.30) 65.04%, rgba(236, 236, 236, 0.30) 104.56%)',

  // Testimonial card background gradient
  testimonialCard:
    'linear-gradient(92deg, rgba(239, 238, 238, 0.70) 0.91%, rgba(255, 253, 250, 0.70) 49.71%, rgba(255, 253, 252, 0.70) 65.04%, rgba(236, 236, 236, 0.70) 104.56%)',

  // Circular progress background gradient using theme colors
  circularProgress:
    'linear-gradient(167deg, rgba(116, 130, 134, 0.15) -3.98%, rgba(178, 202, 204, 0.20) 18.32%, rgba(255, 252, 249, 0.25) 48.83%, rgba(178, 202, 204, 0.20) 80.2%, rgba(116, 130, 134, 0.15) 110.46%), linear-gradient(269deg, #206866 -12.55%, #053736 108.38%)',
} as const;

export const INTERSTITIAL_COLORS = {
  // Text colors using theme variables
  text: {
    primary: 'var(--color-paper)',
    secondary: 'var(--color-ashgray-less-soft)',
    callout: 'var(--color-paper)',
  },

  // Background colors using theme variables
  background: {
    button: 'var(--color-amberblack)',
    calloutBorder: 'rgba(230, 227, 224, 0.15)',
  },

  // Shadow colors using theme variables
  shadow: {
    button: '0px 0px 10px 0px rgba(0, 0, 0, 0.20)',
    image: '0px 0px 30px 0px rgba(0,0,0,0.10)',
    callout: '0px 0px 15px 0px rgba(0,0,0,0.10)',
    testimonialCard: '0px 0px 30px 0px rgba(0, 0, 0, 0.10)',
  },

  // Circle gradient colors using theme variables
  circle: {
    background: {
      start: 'var(--color-silver)',
      middle: 'var(--color-off-white)',
      end: 'var(--color-paper)',
    },
    progress: {
      start: 'var(--color-mint)',
      end: 'var(--color-primary)',
    },
  },
} as const;
